import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useContributionModal } from '../context/ContributionModalContext';
import ContributionModalDataView from './ContributionModalDataView';
import ContributionModalScriptureView from './ContributionModalScriptureView';

const ContributionModalBody: FC = () => {
  const { data } = useContributionModal();

  return (
    <Modal.Body>
      <div className="nk-modal">
        {data.scriptureView ? (
          <ContributionModalScriptureView />
        ) : (
          <ContributionModalDataView />
        )}
      </div>
    </Modal.Body>
  );
};

export default ContributionModalBody;
